<div class="me-dropdown-node-container" [ngClass]="'padd-' + getPadding(node.level)">
  <ap-checkbox [(ngModel)]="node.selected" (onChange)="onNodeSelected()"></ap-checkbox>
  <span>{{node.name}}</span>
</div>
@for (meNode of node.children; track $index) {
<gtw-df-me-dropdown-node [node]="meNode" (nodeSelectionChanged)="onChildrenSelectionChanged($event)"></gtw-df-me-dropdown-node>
}
